import React from 'react';
import { AlertCircle, Clock, CheckCircle2 } from 'lucide-react';
interface KpiCardsProps {
  totalOpen: number;
  closingSoon: number;
  movedToday: number;
}
export function KpiCards({
  totalOpen,
  closingSoon,
  movedToday
}: KpiCardsProps) {
  const cards = [{
    label: 'Open Escalations',
    value: totalOpen,
    icon: AlertCircle,
    iconBg: 'bg-blue-50',
    iconColor: 'text-blue-600'
  }, {
    label: 'Closing Soon (≤ 3 Days)',
    value: closingSoon,
    icon: Clock,
    iconBg: 'bg-red-50',
    iconColor: 'text-red-600'
  }, {
    label: 'Moved to Retention (Today)',
    value: movedToday,
    icon: CheckCircle2,
    iconBg: 'bg-emerald-50',
    iconColor: 'text-emerald-600'
  }];
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-135">
      {cards.map(card => <div key={card.label} className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm flex items-center gap-4 hover:shadow-md hover:border-gray-300 transition-all duration-200 cursor-default" data-id="element-136">
          <div className={`w-11 h-11 rounded-xl ${card.iconBg} flex items-center justify-center ${card.iconColor}`} data-id="element-137">
            <card.icon className="w-5 h-5" data-id="element-138" />
          </div>
          <div data-id="element-139">
            <p className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-140">
              {card.label}
            </p>
            <p className="text-2xl font-bold text-gray-900 mt-0.5" data-id="element-141">
              {card.value}
            </p>
          </div>
        </div>)}
    </div>;
}